/** @type {import('tailwindcss').Config} */
import { withTV } from 'tailwind-variants/transformer'
import tailwindAnimatedPlugin from 'tailwindcss-animate'
import { tailwindColors } from './src/lib/tailwind-colors'

export default withTV({
  content: ['./index.html', './src/**/*.{js,ts,jsx,tsx}', './stories/**/*.{js,jsx,ts,tsx,mdx}'],
  preflight: false,
  corePlugins: { preflight: false },
  theme: {
    container: { center: true, padding: '2rem', screens: { xl: '1196px' } },
    extend: {
      maxWidth: { '6xl': '1228px' },
      screens: { xs: '420px', sm: '640px', md: '768px', lg: '1024px', xl: '1280px', '2xl': '1400px' },
      spacing: {
        section: '34px',
        1: '4px',
        2: '8px',
        3: '12px',
        4: '16px',
        5: '20px',
        6: '24px',
        7: '28px',
        8: '32px',
        9: '36px',
        10: '40px',
        11: '44px',
        12: '48px',
        13: '52px',
        14: '56px',
        15: '60px',
        16: '64px',
        17: '68px',
        18: '72px',
        19: '76px',
        20: '80px',
        21: '84px',
        22: '88px',
        23: '92px',
        24: '96px'
      },
      colors: {
        ...tailwindColors
        // Dont add colors here, add them to the tailwindColors object so storybook can track them
      },
      fontFamily: {
        sans: ['Poppins', 'sans-serif'],
        serif: ['Spartan', 'sans-serif'],
        openSans: ['Open Sans', 'sans-serif'],
        ebGaramond: ['EB Garamond', 'serif'],
        nunito: ['Nunito', 'sans-serif']
      },
      borderRadius: { DEFAULT: '8px', md: '4px' },
      fontSize: {
        xxs: '10px',
        xs: '12px',
        sm: '14px',
        base: '16px',
        lg: '18px',
        xl: '22px',
        '2xl': '24px',
        '3xl': '30px',
        '4xl': '36px',
        '5xl': '40px'
      },
      backgroundImage: {
        'hero-desktop':
          "linear-gradient(360deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%), url('/src/assets/img/home/hero_bg.webp')",
        'home-faq': "url('/src/assets/img/home/home-faq-bg.png')",
        'scheduling-hero-desktop': " url('/src/assets/img/scheduling/scheduling-hero-bg-desktop.webp')",
        'curatorship-hero':
          "linear-gradient(-275deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 90%), url('/src/assets/img/curatorship/curatorship-hero-bg.webp')",
        'curatorship-hero-mobile':
          "linear-gradient(-275deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 90%), url('/src/assets/img/curatorship/curatorship-hero-bg-mobile.webp')",
        'scheduling-hero-mobile': " url('/src/assets/img/scheduling/imagem-home-mobile.png')"
      },
      keyframes: {
        'accordion-down': { from: { height: '0' }, to: { height: 'var(--radix-accordion-content-height)' } },
        'accordion-up': { from: { height: 'var(--radix-accordion-content-height)' }, to: { height: '0' } },
        'auto-carousel': { from: { transform: 'translateX(0)' }, to: { transform: 'translateX(calc(-100%))' } },
        'slide-in-card': {
          from: { opacity: '0', transform: 'translateY(-8px) scale(0.96)' },
          to: { opacity: '1', transform: 'translateY(0) scale(1)' }
        },
        'slide-out-card': {
          from: { opacity: '1', transform: 'translateY(0) scale(1)' },
          to: { opacity: '0', transform: 'translateY(-8px) scale(0.96)' }
        }
      },
      // 'header-desk'/'header-mobile' removidos: a altura do header agora é medida no DOM e
      // publicada em --header-h por HeaderUI. Não reintroduzir a altura como constante.
      animation: {
        'accordion-down': 'accordion-down 0.2s ease-out',
        'accordion-up': 'accordion-up 0.2s ease-out',
        'auto-carousel': 'auto-carousel 200s linear infinite',
        'slide-in-card': 'slide-in-card 0.3s ease-out',
        'slide-out-card': 'slide-out-card 0.2s ease-in'
      }
    }
  },
  plugins: [tailwindAnimatedPlugin]
})
